import React, { useCallback, useEffect, useState } from 'react';
import { Field } from 'redux-form';
import { renderFieldDisabled, renderDollarDisabled, renderNumberPercentage, renderPercentageDisabled, renderToneladasDisabled } from '../../../../../Utils/renderField/renderField';
import { months } from '../../../../../Utils/months';

const ShoppingChipaTable = ({ data, change, step, form_values }) => {
    // Estado para controlar si ya se inicializó
    const [hasInitialized, setHasInitialized] = useState(false);

    // Resetear inicialización cuando cambien los datos principales
    useEffect(() => {
        setHasInitialized(false);
    }, [data && data.data_equivalent_kilos_chipa]);

    const calculateWetKilos = useCallback(() => {
        if (!data || !data.data_equivalent_kilos_chipa || !form_values || !form_values.chipa_table) {
            return;
        }

        const drcRow = form_values.chipa_table[2];
        if (!drcRow) return;

        const updates = {};
        let total = 0;
        let drcSum = 0;
        let drcCount = 0;

        months.forEach(mes => {
            const drcValue = parseFloat(drcRow[mes] || 0);
            const kilosSecos = data.data_equivalent_kilos_chipa[mes] || 0;
            
            if (drcValue > 0 && kilosSecos > 0) {
                const wetKilos = kilosSecos / (drcValue / 100);
                updates[`chipa_table[1].${mes}`] = wetKilos;
                total += wetKilos;
                drcSum += drcValue;
                drcCount++;
            } else {
                updates[`chipa_table[1].${mes}`] = 0;
            }
        });

        updates['chipa_table[1].total'] = total;
        updates['chipa_table[2].total'] = drcCount > 0 ? drcSum / drcCount : 0;

        // Aplicar todas las actualizaciones de una vez
        Object.entries(updates).forEach(([field, value]) => {
            change(field, value);
        });
    }, [data, form_values, change]);

    // Ejecutar cálculo cuando se cargan los datos por primera vez SOLAMENTE
    useEffect(() => {
        // Solo ejecutar si no se ha inicializado aún y hay datos válidos
        if (!hasInitialized && data && data.data_equivalent_kilos_chipa && form_values && form_values.chipa_table) {
            const drcRow = form_values.chipa_table[2];
            if (drcRow) {
                // Verificar si hay al menos un valor de DRC mayor a 0
                const hasValidDrc = months.some(mes => parseFloat(drcRow[mes] || 0) > 0);
                if (hasValidDrc) {
                    calculateWetKilos();
                    setHasInitialized(true); // Marcar como inicializado
                }
            }
        }
    }, [data, form_values, calculateWetKilos, hasInitialized]);

    // Si no hay datos del formulario, mostrar loading
    if (!form_values || !form_values.chipa_table || !Array.isArray(form_values.chipa_table)) {
        return <div>Cargando datos de la tabla...</div>;
    }

    const tableData = form_values.chipa_table;

    return (
        <div className="col-sm-12 form-group np-r p-0">
            <div className="table-responsive">
                <table className="table mb-0 text-center table-striped">
                    <thead>
                        <tr>
                            <th className="custom-cell text-center first-column-shopping text-center table-form-fixed-cell-left-0"></th>
                            <th className="custom-cell text-center text-center table-form-shopping-fixed-cell-left-1">TOTAL ANUAL</th>
                            {Array.from({ length: 12 }, (_, i) => (
                                <th key={i} style={{ width: "6.53%" }}>{i + 1}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody style={{ backgroundColor: "#F0FFC7" }}>
                        {tableData.map((row, index) => (
                            <tr
                                key={index}
                                style={{
                                    ...(index === 6 || index === 7 || index === 8) && { backgroundColor: "#F0FFC7" },
                                    borderBottom: (index === 0 || index === 5 || index === 6 || index === 7) ? "1px solid #035B2F" : "none"
                                }}
                            >
                                <td className="text-center sin-borde-top first-column-shopping table-fixed-cell-left-0">
                                    <Field
                                        name={`chipa_table[${index}].name`}
                                        type="text"
                                        component={renderFieldDisabled}
                                        isTextarea={false}
                                        applyStyles={false}
                                        className="form-control"
                                        placeholder='Nuevo'
                                    />
                                </td>
                                <td className='table-form-shopping-fixed-cell-left-1' style={{ width: "8%" }}>
                                    <Field
                                        name={`chipa_table[${index}].total`}
                                        type="text"
                                        disabled={true}
                                        component={row.is_drc ? renderPercentageDisabled : row.is_kg ? renderToneladasDisabled : renderDollarDisabled}
                                        placeholder='0.00 %'
                                        disabledStyle={index === 0 ? { fontWeight: 'bold' } : {}}
                                        className="form-control"
                                    />
                                </td>
                                {months.map((month) => (
                                    <td key={month} style={{ width: "6.54%" }}>
                                        <Field
                                            name={`chipa_table[${index}].${month}`}
                                            type="text"
                                            component={
                                                step === 1
                                                    ? (row.is_drc ? renderNumberPercentage : row.is_kg ? renderToneladasDisabled : renderDollarDisabled)
                                                    : (row.is_drc ? renderPercentageDisabled : row.is_kg ? renderToneladasDisabled : renderDollarDisabled)
                                            }
                                            className="form-control"
                                            placeholder={row.is_drc ? '0.00 %' : '$ 0.00'}
                                            disabledStyle={index === 0 ? { fontWeight: 'bold' } : {}}
                                        />
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default React.memo(ShoppingChipaTable);